import useMediaQuery from "@/helpers/hooks/useMediaQuery"
import * as React from "react"

const QuickBuyIcon = (props) => {
  const isTabletorMobile = useMediaQuery("(max-width: 1024px)");
  return (<>
  {isTabletorMobile ? (<svg xmlns="http://www.w3.org/2000/svg" width={17} height={11} {...props}>
    <title>{"QuickBuy"}</title>
    <g fill="none" fillRule="evenodd" stroke="#2F2F30">
      <path d="M7.411 3.722A1.497 1.497 0 0 1 8.9 5.027l.495 3.778c.053.41-.064.805-.298 1.109-.229.297-.568.51-.966.57L2.28 10.5c-.414 0-.79-.168-1.06-.44a1.495 1.495 0 0 1-.44-1.03l.507-4.003a1.497 1.497 0 0 1 1.488-1.305Z" />
      <path d="M3.246 3.778C3.246 2.12 3.954 1 5.094 1 6.234 1 6.95 2.12 6.95 3.778" />
      <g strokeLinecap="round" strokeWidth={0.8}>
        <path d="M11.636 3.182H16M13.818 1v4.364" />
      </g>
    </g>
  </svg>) :
  (
    <svg xmlns="http://www.w3.org/2000/svg" width={22} height={16} {...props}>
    <title>{"QuickBuy"}</title>
    <g fill="none" fillRule="evenodd" stroke="#2F2F30">
      <path d="M11.995 4.833a1.497 1.497 0 0 1 1.487 1.306l1.004 7.666c.054.41-.064.805-.298 1.109-.228.297-.567.51-.965.57L2.28 15.5c-.414 0-.79-.168-1.06-.44a1.495 1.495 0 0 1-.44-1.03l1.017-7.891a1.497 1.497 0 0 1 1.487-1.306Z" />
      <path d="M4.87 5.167C4.87 2.679 5.93 1 7.64 1c1.71 0 2.785 1.68 2.785 4.167" />
      <g strokeLinecap="round" strokeWidth={0.8}>
        <path d="M15 3.813h5.625M17.813 1v5.625" />
      </g>
    </g>
  </svg>
  )
  }
  </>);
};

export default QuickBuyIcon
